import React, { useState, useEffect } from "react";
import "./SideBar.css";
import { NavLink, Route, Routes } from "react-router-dom";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import {
  MdOutlineHome,
  MdOutlinePerson,
  MdBusiness,
  MdOutlineAddShoppingCart,
  MdOutlineCategory,
  MdOutlineContentPasteGo,
  MdOutlineAddCard,
  MdOutlineFeed,
  MdMenuBook,
} from "react-icons/md";
import { PiUsers } from "react-icons/pi";
import { LuDot } from "react-icons/lu";
import { Collapse } from "react-bootstrap";
import { Header } from "./Header";
import Dashboard from "../pages/Dashboard";
import ProductList from "../pages/ProductList";
import CategoryList from "../pages/CategoryList";
import UnitList from "../pages/UnitList";
import ItemCreation from "../pages/ItemCreation";
import Party from "../pages/PurchaseParty";
import SalesParty from "../pages/SalesParty";
import PurchaseBill from "../pages/PurchaseBilllisting";
import PayOut from "../pages/PayOut";
import { PurchaseBillEntry } from "../pages/PurchaseBills";
import SalesInvoice from "../pages/SalesInvoice";
import SalesInvoiceEntry from "../pages/SalesBills";

import PayIn from "../pages/PayIn";
import Expenses from "../pages/Expenses";
import User from "../pages/User";
import Company from "../pages/Company";
import DayBook from "../pages/DayBook";
import Reports from "../pages/Reports";
import WholeSaleInvoice from "../pages/WholeSaleInvoice";
import WholeSaleBillEntry from "../pages/WholeSaleBillEntry";

const SideBar = () => {
  const [openMenu, setOpenMenu] = useState(
    JSON.parse(localStorage.getItem("openMenu")) || {}
  );

  // Retrieve logged-in user data from localStorage
  const loggedInUser = JSON.parse(localStorage.getItem("loggedInUser")) || {};
  const { user_type, staff_permission } = loggedInUser;

  // Parse staff_permission string into an array, removing curly braces and splitting by comma
  const permissions = staff_permission
    ? staff_permission
        .replace("{", "")
        .replace("}", "")
        .split(",")
        .map((perm) => perm.trim())
    : [];

  const handleMenuClick = (menuIndex) => {
    setOpenMenu((prevOpenMenu) => {
      const newOpenMenu = {};
      for (let key in prevOpenMenu) {
        newOpenMenu[key] = false;
      }
      newOpenMenu[menuIndex] = !prevOpenMenu[menuIndex];
      return newOpenMenu;
    });
  };

  useEffect(() => {
    localStorage.setItem("openMenu", JSON.stringify(openMenu));
  }, [openMenu]);

  const handleLinkClick = () => {
    if (window.innerWidth <= 768) {
      document.body.classList.remove("toggle-sidebar");
    }
  };

  // Check if a menu item should be displayed based on user_type and permissions
  const canShowMenu = (menuPermission) => {
    if (user_type !== "staff") return true; // Show all menus for non-staff users
    return permissions.includes(menuPermission);
  };

  return (
    <div className="">
      <Header />
      <aside id="side-bar" className="side-bar">
        <div className="list-group">
          <ul>
            {/* Home is always visible */}
            <li>
              <NavLink
                to="/dashboard"
                className="nav-link"
                onClick={handleLinkClick}
              >
                <span className="list-icon">
                  <MdOutlineHome />
                </span>
                <span className="list-text">Home</span>
              </NavLink>
            </li>

            {/* User & Access */}
            {canShowMenu("User") && (
              <li>
                <NavLink
                  to="/console/user"
                  className="nav-link"
                  onClick={handleLinkClick}
                >
                  <span className="list-icon">
                    <MdOutlinePerson />
                  </span>
                  <span className="list-text">User & Access</span>
                </NavLink>
              </li>
            )}

            {/* Company */}

            {/* <li>
              <NavLink
                to="/console/company"
                className="nav-link"
                onClick={handleLinkClick}
              >
                <span className="list-icon">
                  <MdBusiness />
                </span>
                <span className="list-text">Company</span>
              </NavLink>
            </li> */}

            {/* Parties submenu */}
            {/* {canShowMenu("Parties") && (
              <li>
                <div
                  className="sub-menu nav-link"
                  onClick={() => handleMenuClick(0)}
                >
                  <span className="list-icon">
                    <PiUsers />
                  </span>
                  <span className="list-text">Parties</span>
                  <span
                    className={`list-icon arrow ${openMenu[0] ? "rotate" : ""}`}
                  >
                    <MdOutlineKeyboardArrowRight />
                  </span>
                </div>
                <Collapse in={openMenu[0]}>
                  <ul className="submenu-list">
                    <li>
                      <NavLink
                        to="/console/party/purchase"
                        className="nav-link"
                        onClick={handleLinkClick}
                      >
                        <span className="list-icon">
                          <LuDot />
                        </span>
                        <span className="list-text">Purchase</span>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to="/console/party/sales"
                        className="nav-link"
                        onClick={handleLinkClick}
                      >
                        <span className="list-icon">
                          <LuDot />
                        </span>
                        <span className="list-text">Customer</span>
                      </NavLink>
                    </li>
                  </ul>
                </Collapse>
              </li>
            )} */}

            {/* Items submenu */}
            {/* {canShowMenu("Items") && (
              <li>
                <div
                  className="sub-menu nav-link"
                  onClick={() => handleMenuClick(1)}
                >
                  <span className="list-icon">
                    <MdOutlineCategory />
                  </span>
                  <span className="list-text">Items</span>
                  <span
                    className={`list-icon arrow ${openMenu[1] ? "rotate" : ""}`}
                  >
                    <MdOutlineKeyboardArrowRight />
                  </span>
                </div>
                <Collapse in={openMenu[1]}>
                  <ul className="submenu-list">
                    <li>
                      <NavLink
                        to="/console/item/category"
                        className="nav-link"
                        onClick={handleLinkClick}
                      >
                        <span className="list-icon">
                          <LuDot />
                        </span>
                        <span className="list-text">Category</span>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to="/console/item/unit"
                        className="nav-link"
                        onClick={handleLinkClick}
                      >
                        <span className="list-icon">
                          <LuDot />
                        </span>
                        <span className="list-text">Unit</span>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to="/console/item/product"
                        className="nav-link"
                        onClick={handleLinkClick}
                      >
                        <span className="list-icon">
                          <LuDot />
                        </span>
                        <span className="list-text">Products</span>
                      </NavLink>
                    </li>
                  </ul>
                </Collapse>
              </li>
            )} */}

            {/* Purchase submenu */}
            {/* {canShowMenu("Purchase") && (
              <li>
                <div
                  className="sub-menu nav-link"
                  onClick={() => handleMenuClick(2)}
                >
                  <span className="list-icon">
                    <MdOutlineAddShoppingCart />
                  </span>
                  <span className="list-text">Purchase</span>
                  <span
                    className={`list-icon arrow ${openMenu[2] ? "rotate" : ""}`}
                  >
                    <MdOutlineKeyboardArrowRight />
                  </span>
                </div>
                <Collapse in={openMenu[2]}>
                  <ul className="submenu-list">
                    <li>
                      <NavLink
                        to="/console/purchase/bill"
                        className="nav-link"
                        onClick={handleLinkClick}
                      >
                        <span className="list-icon">
                          <LuDot />
                        </span>
                        <span className="list-text">Bill</span>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to="/console/purchase/payout"
                        className="nav-link"
                        onClick={handleLinkClick}
                      >
                        <span className="list-icon">
                          <LuDot />
                        </span>
                        <span className="list-text">Pay Out</span>
                      </NavLink>
                    </li>
                  </ul>
                </Collapse>
              </li>
            )} */}

            {/* Sales submenu */}
            {canShowMenu("Sales") && (
              <li>
                <div
                  className="sub-menu nav-link"
                  onClick={() => handleMenuClick(3)}
                >
                  <span className="list-icon">
                    <MdOutlineContentPasteGo />
                  </span>
                  <span className="list-text">Sales</span>
                  <span
                    className={`list-icon arrow ${openMenu[3] ? "rotate" : ""}`}
                  >
                    <MdOutlineKeyboardArrowRight />
                  </span>
                </div>
                <Collapse in={openMenu[3]}>
                  <ul className="submenu-list">
                    <li>
                      <NavLink
                        to="/console/sales/invoice"
                        className="nav-link"
                        onClick={handleLinkClick}
                      >
                        <span className="list-icon">
                          <LuDot />
                        </span>
                        <span className="list-text">Bill</span>
                      </NavLink>
                    </li>
                    {/* <li>
                      <NavLink
                        to="/console/sales/wholesale"
                        className="nav-link"
                        onClick={handleLinkClick}
                      >
                        <span className="list-icon">
                          <LuDot />
                        </span>
                        <span className="list-text">Whole Sale</span>
                      </NavLink>
                    </li> */}
                    {/* <li>
                      <NavLink
                        to="/console/sales/payin"
                        className="nav-link"
                        onClick={handleLinkClick}
                      >
                        <span className="list-icon">
                          <LuDot />
                        </span>
                        <span className="list-text">Pay In</span>
                      </NavLink>
                    </li> */}
                  </ul>
                </Collapse>
              </li>
            )}

            {/* Expense */}
            {canShowMenu("Expense") && (
              <li>
                <NavLink
                  to="/console/expense"
                  className="nav-link"
                  onClick={handleLinkClick}
                >
                  <span className="list-icon">
                    <MdOutlineAddCard />
                  </span>
                  <span className="list-text">Expense</span>
                </NavLink>
              </li>
            )}
            {/* Report */}
            {canShowMenu("Report") && (
              <li>
                <NavLink
                  to="/console/report"
                  className="nav-link"
                  onClick={handleLinkClick}
                >
                  <span className="list-icon">
                    <MdMenuBook />
                  </span>
                  <span className="list-text">Report</span>
                </NavLink>
              </li>
            )}
          </ul>
        </div>
      </aside>
      <div id="main">
        <Routes>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/console/user" element={<User />} />
          <Route path="/console/company" element={<Company />} />
          <Route path="/console/party/purchase" element={<Party />} />
          <Route path="/console/party/sales" element={<SalesParty />} />
          <Route path="/console/item/product" element={<ProductList />} />
          <Route path="/console/item/category" element={<CategoryList />} />
          <Route path="/console/item/unit" element={<UnitList />} />
          <Route path="/console/item/create" element={<ItemCreation />} />
          <Route path="/console/purchase/bill" element={<PurchaseBill />} />
          <Route path="/console/purchase/payout" element={<PayOut />} />
          <Route
            path="/console/purchase/bill/create"
            element={<PurchaseBillEntry />}
          />
          <Route path="/console/sales/invoice" element={<SalesInvoice />} />
          <Route
            path="/console/invoice/create"
            element={<SalesInvoiceEntry />}
          />
          <Route
            path="/console/sales/wholesale"
            element={<WholeSaleInvoice />}
          />
          <Route
            path="/console/wholesale/create"
            element={<WholeSaleBillEntry />}
          />

          <Route path="/console/sales/payin" element={<PayIn />} />
          <Route path="/console/expense" element={<Expenses />} />
          <Route path="/console/daybook" element={<DayBook />} />
          <Route path="/console/report" element={<Reports />} />
        </Routes>
      </div>
    </div>
  );
};

export default SideBar;
